// extracted by mini-css-extract-plugin
export default {"container":"SelectedQuotes_container__h0JVo"};